export default class Room{
    id:string;
    name:string;
    creatorUserName:string;
    creationTime:Date;
    countAisles:number;
}